import React from 'react';

import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from 'twyne-new.ui';

import GlobalInput from 'components/form/Input';

function InputMergeTag({ mergetags, ...props }) {
  return <Input
    {...props}
    validations={{
      mergeTagValid: (_, value) => !/[{}]/.test(value.replace(/{(\w+)}/g, ($1, $2) => mergetags.find(d => d && d[0] === $2) ? '' : $1)),
    }}
    validationErrors={{
      mergeTagValid: 'Merge Tags invalid',
    }}
  />
}

function DropdownMergeTag({ children, target, onChange, mergetags, className = '' }) {
  return <DropdownMenu className={className} size='sm'>
    <DropdownMenuTrigger asChild>
      {children}
    </DropdownMenuTrigger>
    <DropdownMenuContent className='max-h-60 overflow-y-auto'>
      {mergetags.map((mergetag, idx) => {
        const [key, label] = mergetag || []
        return <DropdownMenuItem divider={!mergetag} key={idx}
          onClick={() => handleAddMergeTag(key, target, onChange)}
        >
          {label}
        </DropdownMenuItem>
      })}
    </DropdownMenuContent>
  </DropdownMenu>
}

const handleAddMergeTag = (mergetag, targetId, callbackChange) => {
  const target = document.getElementById(targetId)

  if (!target) {
    return
  }

  mergetag = `{${mergetag}}`

  if (target.setRangeText) {
    target.setRangeText(mergetag)
  } else {
    target.focus()
    document.execCommand('insertText', false, mergetag);
  }
  callbackChange(target.value)
}

function Input({ onChange, ...props }) {
  const handleChange = evt => {
    onChange && onChange(evt.target.value)
  }
  return <GlobalInput {...props} onChange={handleChange} />
}

export {
  Input,
  InputMergeTag,
  DropdownMergeTag,
}
